export default class ExperienceRoomRateDisplay {
  constructor({ trackingId, experienceIds, qubitService }) {
    this.trackingId = trackingId
    this.experienceIds = experienceIds
    this.qubitService = qubitService
  }

  async showDefaultRoomDisplay() {
    let experience = null
    try {
      experience = await this.qubitService.newExperience({
        trackingId: this.trackingId,
        experienceIds: this.experienceIds
      })
      const [{ callback, isControl }] = experience.experiencePayloads
      this.qubitService.checkExperience({ checkCallback: callback })

      return isControl
    } catch (err) {
      // No exist experience
      return undefined
    }
  }
}
